import React, { useEffect } from "react";
import { Spinner } from "reactstrap";

import { useImage } from "@common/util/useImage";

type Props = Readonly<{
  context: CanvasRenderingContext2D;
  height: number;
  index: number;
  markPageReady: (page: number) => void;
  readyPages: Array<boolean>;
  src: string;
  width: number;
  x: number;
  y: number;
}>;

export const BackgroundImage = ({
  context,
  height,
  index,
  markPageReady,
  readyPages,
  src,
  width,
  x,
  y,
}: Props) => {
  const [image, status] = useImage(src, true, true);
  useEffect(() => {
    if (status !== "loaded" || !image) {
      context.save();
      context.fillStyle = "white";
      context.fillRect(x, y, width, height);
      context.restore();
      return;
    }
    context.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight, x, y, width, height);
    if (!readyPages[index]) {
      setTimeout(() => {
        markPageReady(index);
      }, 1000);
    }
  });
  if (status === "loaded" && image) {
    return null;
  }
  return <Spinner className="image-loading" style={{ top: `${height / 2 + y}px` }} />;
};
BackgroundImage.displayName = "BackgroundImage";
